import React, { useCallback, useState } from 'react';
import t from '~t';
import { useDispatch } from 'react-redux';
import { backup } from '~data/actions/user';

import { Alert, Item, ItemIcon, ItemTitle, Icon } from '~ui';

export default function SettingsBackupsAdd() {
  const [creating, setCreating] = useState(false);

  const dispatch = useDispatch();
  const onClickNew = useCallback(
    (e) => {
      e.preventDefault();
      dispatch(backup());
      setCreating(true);
    },
    [dispatch],
  );

  if (creating)
    return <Alert variant='success'>{t.s('backupCreating')}</Alert>;

  return (
    <Item as='a' href='' onClick={onClickNew}>
      <ItemIcon>
        <Icon name='add' />
      </ItemIcon>
      <ItemTitle>{t.s('createNew')}</ItemTitle>
    </Item>
  );
}
